export default "__VITE_ASSET__BaTbNGpL__"